import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import ChatInterface from "./components/ChatInterface.jsx";
import Login from "./components/Login.jsx";
import Callback from "./components/Callback.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import { Home } from "./components/Home.jsx";
import Contact from "./components/Contact.jsx";
import { PostHogProvider } from "./components/PostHogProvider.jsx";
import { usePostHogAuth } from "./hooks/usePostHogAuth.js";
import config from "./config";
import "./App.css";

// Main Layout component
const MainLayout = () => {
  const { isAuthenticated, user, logout } = useAuth0();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  
  // Initialize PostHog auth tracking
  usePostHogAuth();
  
  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };
  
  const closeMobileNav = () => {
    setIsMobileNavOpen(false);
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-left">
          <button 
            className="mobile-menu-button"
            onClick={toggleMobileNav}
            aria-label="Toggle chat navigation"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
          <h1>
            <img src="/ChatWDL_logo.png" alt="ChatWDL Logo" style={{ height: '40px', width: 'auto' }} />
          </h1>
        </div>
        <div className="header-right">
          {isAuthenticated && (
            <p>Welcome, {user?.name}</p>
          )}
          <Login />
        </div>
      </header>
      <main>
        {isAuthenticated ? (
          <ChatInterface 
            isMobileNavOpen={isMobileNavOpen}
            closeMobileNav={closeMobileNav}
          />
        ) : (
          <Home />
        )}
      </main>
    </div>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <PostHogProvider>
        <Auth0Provider
          domain={config.auth0.domain}
          clientId={config.auth0.clientId}
          authorizationParams={{
            redirect_uri: config.auth0.redirectUri,
            audience: config.auth0.audience,
            scope: 'openid profile email offline_access'
          }}
          cacheLocation="localstorage"
          useRefreshTokens={true}
        >
          <Router>
            <Routes>
              <Route path="/callback" element={<Callback />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/chat/:conversationId?" element={<MainLayout />} />
              <Route path="/*" element={<MainLayout />} />
            </Routes>
          </Router>
        </Auth0Provider>
      </PostHogProvider>
    </ErrorBoundary>
  );
}

export default App;
